import { Button, Modal } from 'antd'
import { useNavigate } from 'react-router-dom'

import type { ValidationErrorResponse } from '@/types'
import { findOfferLine, type OfferLine } from '@/utils/products/offerLines'

import cn from './ValidationErrorModal.module.scss'

interface ValidationErrorModalProps {
  error: ValidationErrorResponse | null
  lines: OfferLine[]
  onClose: () => void
  isOnCartPage?: boolean
}

function ValidationErrorModal({
  error,
  lines,
  onClose,
  isOnCartPage = true,
}: ValidationErrorModalProps) {
  const navigate = useNavigate()

  if (!error) return null

  const handleClose = () => {
    onClose()
    if (!isOnCartPage) {
      navigate('/cart')
    }
  }

  return (
    <Modal
      open
      title={<div className={cn.title}>⚠️ Ошибка при проверке заказа</div>}
      onCancel={handleClose}
      footer={[
        <Button
          key="back"
          type="primary"
          size="large"
          onClick={handleClose}
          className={cn.closeButton}
        >
          {isOnCartPage ? 'ОК' : 'Вернуться в корзину'}
        </Button>,
      ]}
      width={700}
      centered
      maskClosable={false}
    >
      <div className={cn.summary}>
        <p className={cn.summaryText}>{error.message}</p>
      </div>

      <div>
        <p className={cn.detailsTitle}>Детали ошибок:</p>
        <div className={cn.detailsList}>
          {error.details.map((detail, index) => {
            const line = findOfferLine(lines, detail.context)

            return (
              <div key={index} className={cn.detail}>
                <div className={cn.detailMessage}>
                  <p className={cn.detailMessageText}>{detail.message}</p>
                </div>

                {line && (
                  <div className={cn.product}>
                    <div className={cn.productNameRow}>
                      <strong className={cn.productName}>
                        {line.description}
                      </strong>
                    </div>
                    <div className={cn.productMeta}>
                      <span className={cn.productMetaLabel}>Артикул:</span>{' '}
                      <strong>{line.article}</strong>
                      {line.brandName && (
                        <>
                          {' • '}
                          <span className={cn.productMetaLabel}>
                            Бренд:
                          </span>{' '}
                          <strong>{line.brandName}</strong>
                        </>
                      )}
                      {' • '}
                      <span className={cn.productMetaLabel}>Склад:</span>{' '}
                      <strong className={cn.productStore}>
                        {line.storeName}
                      </strong>
                    </div>
                  </div>
                )}
              </div>
            )
          })}
        </div>
      </div>

      {!!error.traceId && (
        <div className={cn.traceId}>TraceID: {error.traceId}</div>
      )}
    </Modal>
  )
}

export default ValidationErrorModal
